<template>
	<div class="tabTableExceptionsWrap">
		<main-table-all-back
				v-if="exceptionCloseLimit"
				:key="'exceptions-table-close'"
				:flag="flag"
				:headers="getHeaders"
				:list="exceptionClosed"

				:total-pages="exceptionCloseTotal"
				:totals="exceptionCloseTotals"
				:defaultOrder="exceptionCloseOrder"
				:defaultSort="exceptionCloseSort"
				:limit-pages="exceptionCloseLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				:isExport="false"
				:is-create="false"
				:is-settings="false"
				:is-filter-refresh="false"
				:is-search="false"

				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
		></main-table-all-back>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { headers } from "@/pages/Safety/LogbooksList/Exception/constants";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import { TAB } from "@/constants/constants";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Close",
	components: { MainTableAllBack },
	props: {
		preload: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters([
			"exception",
			"exceptionClosed",
			"exceptionCloseLimit",
			"exceptionOrder",
			"exceptionSort",
			"exceptionTotal",
			"exceptionTotals",
			"exceptionCloseTotal",
			"exceptionCloseTotals",
			"exceptionCloseOrder",
			"exceptionCloseSort",
		]),
		getHeaders() {
			return headers;
		},
	},
	data: () => ({
		flag: TAB.EXCEPTION_TABLE_MODAL,
		type: 0,
		isLoaded: false,
		isLoading: false,
		defaultFilter: {},
		activeTableFilters: null,

		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)

	}),
	methods: {
		...mapActions([
			"getExceptionList",
		]),

		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

		async onUpdateFilters(filters, isWithoutFilters) {
			const { type } = this.$data;
			await this.getExceptionList({ type, filters });
			console.log('%c [  isWithoutFilters  ] ', 'color:#bada55', typeof isWithoutFilters, isWithoutFilters );
			// if (!isWithoutFilters) await this.getExceptionList({ type, filters });
		},

		async onList(values) {
			console.log('%c [  values  ] ', 'color:#bada55', values );
			const { value, flag } = values;
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getExceptionList({ type: this.type, filters: value });
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value );
			}
		},

		onClickButton({ key, item }) {
			this.$emit("updateEdit", { key, item });
		},
		onEdit({ line }) {
			this.$emit("updateEdit", { key: "edit", item: line });
		},
	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>

<style scoped lang="scss">
.tabTableExceptionsWrap {
	height: calc(100vh - 232px);
	overflow: auto;
}
</style>
